import { render, staticRenderFns } from "./rule-form.vue?vue&type=template&id=65c3d437&scoped=true&lang=pug&"
import script from "./rule-form.vue?vue&type=script&lang=ts&"
export * from "./rule-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3d437",
  null
  
)

export default component.exports